(() => {
  const storageKey = 'hugfig:last-continue-shopping-url';

  const isStorefrontUrl = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin && !url.pathname.startsWith('/cart');
    } catch {
      return false;
    }
  };

  const isCartPage = () => document.querySelector('main[data-template="cart"]') !== null;

  const saveCurrentPageUrl = () => {
    if (isCartPage()) return;

    try {
      window.sessionStorage.setItem(
        storageKey,
        `${window.location.pathname}${window.location.search}${window.location.hash}`
      );
    } catch {
      // The Liquid fallback link still returns customers to the storefront home page.
    }
  };

  const updateContinueShoppingLinks = () => {
    let lastPageUrl = null;

    try {
      lastPageUrl = window.sessionStorage.getItem(storageKey);
    } catch {
      return;
    }

    if (!lastPageUrl || !isStorefrontUrl(lastPageUrl)) return;

    document.querySelectorAll('[data-hugfig-continue-shopping]').forEach((link) => {
      link.href = lastPageUrl;
    });
  };

  saveCurrentPageUrl();
  updateContinueShoppingLinks();
  document.addEventListener('shopify:section:load', updateContinueShoppingLinks);
})();
